// App-typed Redux hooks.
//
// Converted consumers should import `useSelector` from here instead of
// `react-redux`, so the selector's `state` argument resolves to RootState
// without a per-call generic. (react-redux 8 has no `useSelector.withTypes`;
// the TypedUseSelectorHook alias is the v8 equivalent.)

import { useSelector as useReduxSelector, type TypedUseSelectorHook } from 'react-redux'
import type { RootState } from 'store/types'

// Delegates on each call rather than aliasing the import. Assigning the imported
// function to a const captures it at module-eval time, which silently defeats the
// existing tests that drive components by spying on `react-redux`'s useSelector —
// they replace the module property after this module has already read it, so the
// real hook runs and fails for want of a Provider.
export const useSelector: TypedUseSelectorHook<RootState> = (selector, equalityFn) =>
  useReduxSelector(selector, equalityFn)
